// extracted by mini-css-extract-plugin
export default {"notFoundView":"NotFoundView_notFoundView__eEUKu"};